import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// ------------------------------------------------------
import "./css.css";

// ------------------------------------------------------
// ------------------------------------------------------
const Index = () => {
  const dispatch = useDispatch();

  const conversions = useSelector((state) => state.conversions);
  const { converters, showConverters } = conversions;
  const extensions = Object.keys(converters);

  useEffect(() => {
    dispatch({ type: "INIT_CONVERTERS" });
  }, [dispatch]);

  if (!showConverters) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head convert">
          <div className="header">
            <p className="modal-card-title">New Check-In</p>
          </div>
        </header>
        <section className="modal-card-body">
          <table className="table is-fullwidth converter-table is-striped">
            <tbody>
              {extensions.map((ext) => (
                <ProgressRow converter={converters[ext]} key={ext} />
              ))}
            </tbody>
          </table>
        </section>
        <footer className="modal-card-foot"></footer>
      </div>
    </div>
  );
};
export default Index;

// ---------------------------------------------------------------
// ---------------------------------------------------------------
const ProgressRow = ({ converter }) => {
  const { nFiles, pointer, status } = converter;
  const isDone = !nFiles || !pointer || status === "done";
  const percentage = Math.round((pointer / nFiles) * 100);
  return (
    <tr style={{ height: "42px" }}>
      <td width="30%" style={{ verticalAlign: "middle" }}>{converter.headline}</td>
      <td className="converter-status" style={{ width: "60px", textAlign: "right", verticalAlign: "middle" }}>
        {status !== null ? (
          isDone ? (
            <div className="tag is-success">
              100%
            </div>
          ) : (
            <div className="tag">
              {percentage}%
            </div>
          )
        ) : <div className="tag" style={{ visibility: "hidden" }}>0%</div>}
      </td>
      <td style={{ verticalAlign: "middle" }}>
        {status === "progress" ? (
          nFiles === null || pointer === null ? (
            <progress className="is-small progress is-warning" value={null} />
          ) : (
            <progress
              className="is-small progress is-warning"
              value={pointer}
              max={nFiles}
            />
          )
        ) : status === "done" ? (
          <progress
            className="is-small progress is-primary"
            value={10}
            max={10}
          />
        ) : (
          <progress
            className="is-small progress is-primary"
            value={0}
            max={10}
          />
        )}
      </td>
    </tr>
  );
};
